jQuery(function ($) {

  $('#search-results-container').on("click", ".add-new-job-alert", function (e) {
    e.preventDefault();
    $('#modal-add-job-alert').addClass('open');
    $('body').addClass('open-modal-job-alert');
    $('.container-form-add-job-alert .message').addClass('error').html('');
  });

  $('#search-link').on("click", ".add-new-job-alert", function (e) {
    e.preventDefault();
    $('#modal-add-job-alert').addClass('open');
    $('body').addClass('open-modal-job-alert');
    $('.container-form-add-job-alert .message').addClass('error').html('');
  });

  $('body').on("click", "#modal-add-job-alert .btn-close-job-alert", function (e) {
    e.preventDefault();
    $('#modal-add-job-alert').removeClass('open');
    $('body').removeClass('open-modal-job-alert');
  });

  $('body').on("click", "#modal-update-job-alert .btn-close-job-alert", function (e) {
    e.preventDefault();
    $('#modal-update-job-alert').removeClass('open');
    $(".container-form-update-job-alert .title").empty();
    $(".form-update-job-alert--wrapper").empty();
  });

  $('body').on("click", ".submit-add-job-alert", function (e) {
    e.preventDefault();

    var categories = $("#field_categorie option:selected").val();
    var enseigne = $("#field_enseigne option:selected").val();
    var departement = $("#field_departement option:selected").val();
    var contrat = $("#field_contrat option:selected").val();
    var libelle = $("input[name='libelle']").val();
    var frequency = $('input[name=frequency]:checked').val();

    if (libelle == '') {
      $('.container-form-add-job-alert .message').addClass('error').html("La description n'a pas été renseignée.");
    } else {
      $.ajax({
        url: '/ajax/espace-candidat/add-job-alert',
        type: 'POST',
        data: {
          'categories': categories,
          'enseigne': enseigne,
          'departement': departement,
          'contrat': contrat,
          'libelle': libelle,
          'frequency': frequency
        },
        success: function (success) {
          if(success.job_alert == 'exist') {
            $('#modal-add-job-alert .message').addClass('error').html("L'alerte a été déja été créée.");
          } else {
            //$('#modal-add-job-alert').removeClass('open');
            $("input[name='libelle']").val('');
            $('.container-form-add-job-alert .message').removeClass('error').html("L'alerte a été créée dans votre espace candidat.");
          }
        }, error: function (xhr, ajaxOptions, thrownError) {
          console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      });
    }
  });

  $('.page-espace-candidat').on("click", ".update-job-offer-alert", function (e) {
    e.preventDefault();
    var id = $(this).data('job-alert');

    $.ajax({
      url: '/ajax/espace-candidat/update-job-alert',
      type: 'GET',
      data: {
        'id': id,
      },
      success: function (success) {
        $(".container-form-update-job-alert .title").html('Modifier mon alerte');
        $('.container-form-update-job-alert .message').removeClass('error').html('');
        $(".form-update-job-alert--wrapper").empty().html(success);
        $('#modal-update-job-alert').addClass('open');
      }, error: function (xhr, ajaxOptions, thrownError) {
        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  });

  $('.page-espace-candidat').on("click", ".submit-update-job-alert", function (e) {
    e.preventDefault();
    var self = $(this);
    var id = $("input[name='id']").val();
    var libelle = $("input[name='libelle']").val();
    var frequency = $('input[name=frequency]:checked').val();

    if (libelle == '' || id == '') {
      $('.container-form-update-job-alert .message').addClass('error').html("La description n'a pas été renseignée.");
    } else {
      $.ajax({
        url: '/ajax/espace-candidat/update-job-alert',
        type: 'GET',
        data: {
          'id': id,
          'type': 'update',
          'libelle': libelle,
          'frequency': frequency
        },
        success: function (success) {
          $('.container-form-update-job-alert .message').removeClass('error').html('');
          $(".container-form-update-job-alert .title").html('Modifier mon alerte');
          $(".form-update-job-alert--wrapper").empty().html(success);
          $('#modal-update-job-alert').removeClass('open');
          $(".container-form-update-job-alert .title").empty();
          $(".form-update-job-alert--wrapper").empty();
          $(".alert-job-" + id).children(".alert-job-title").html(libelle);
        }, error: function (xhr, ajaxOptions, thrownError) {
          console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      });
    }
  });

  $('.page-espace-candidat').on("click", ".delete-job-offer-alert", function (e) {
    e.preventDefault();
    var id = $(this).data('job-alert');
    var self = $(this);

    $.ajax({
      url: '/ajax/espace-candidat/update-job-alert',
      type: 'GET',
      data: {
        'id': id,
        'type': 'delete',
      },
      success: function (success) {
        self.parent().remove();
      }, error: function (xhr, ajaxOptions, thrownError) {
        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  });
});
